(function () {
  if (customElements.get('cogi-games-search')) return;

  function norm(s) {
    return String(s).toLowerCase().normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9一-鿿]+/g, ' ')
      .trim();
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  class CogiGamesSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('.cgs__input');
      this.results = this.querySelector('.cgs__results');
      this.small = this.dataset.tierSmall || '64 GB';
      this.large = this.dataset.tierLarge || '128 GB';
      this.email = this.dataset.email || '';
      this.max = parseInt(this.dataset.max, 10) || 20;
      this.data = null;
      this.loading = false;

      var self = this;
      this.input.addEventListener('focus', function () { self.load(); }, { once: true });
      this.input.addEventListener('input', function () {
        clearTimeout(self._t);
        self._t = setTimeout(function () { self.search(); }, 180);
      });
    }

    load() {
      if (this.data || this.loading) return;
      this.loading = true;
      var self = this;
      fetch(this.dataset.url)
        .then(function (r) { return r.json(); })
        .then(function (rows) {
          self.data = rows.map(function (r) { return { n: r[0], f: r[1], s: norm(r[0]) }; });
        })
        .catch(function () {
          self.data = [];
          self.results.innerHTML = '<div class="cgs__msg">Could not load the game list. Please refresh the page.</div>';
        })
        .finally(function () {
          self.loading = false;
          if (self.input.value.trim()) self.search();
        });
    }

    search() {
      var raw = this.input.value.trim();
      var q = norm(raw);
      if (!q) { this.results.innerHTML = ''; return; }

      if (!this.data) {
        this.results.innerHTML = '<div class="cgs__msg">Loading the game list…</div>';
        this.load();
        return;
      }

      var words = q.split(' ');
      var hits = this.data.filter(function (g) {
        for (var i = 0; i < words.length; i++) {
          if (g.s.indexOf(words[i]) === -1) return false;
        }
        return true;
      }).sort(function (a, b) {
        var ap = a.s.indexOf(q) === 0 ? 0 : 1;
        var bp = b.s.indexOf(q) === 0 ? 0 : 1;
        if (ap !== bp) return ap - bp;
        if (a.s.length !== b.s.length) return a.s.length - b.s.length;
        return a.n.localeCompare(b.n);
      });

      if (hits.length === 0) {
        var mail = this.email
          ? ' Email <a href="mailto:' + esc(this.email) + '">' + esc(this.email) + '</a> and we will check the card for you before you order.'
          : '';
        this.results.innerHTML =
          '<div class="cgs__msg">No match for “<strong>' + esc(raw) + '</strong>” in our catalogue.' + mail + '</div>';
        return;
      }

      var self = this;
      var shown = hits.slice(0, this.max);
      var html = shown.map(function (g) {
        var onSmall = (g.f & 1) !== 0;
        var onLarge = (g.f & 2) !== 0;
        var badge = '';
        if (!onSmall && onLarge) badge = 'Only on ' + self.large;
        else if (onSmall && !onLarge) badge = 'Only on ' + self.small;
        return '<div class="cgs__item"><span class="cgs__name">' + esc(g.n) + '</span>' +
          (badge ? '<span class="cgs__badge">' + esc(badge) + '</span>' : '') + '</div>';
      }).join('');

      if (hits.length > shown.length) {
        html += '<div class="cgs__msg">+ ' + (hits.length - shown.length) + ' more matching “' + esc(raw) + '”</div>';
      }

      this.results.innerHTML = html;
    }
  }

  customElements.define('cogi-games-search', CogiGamesSearch);
})();
